@if (isValidIndicator) {
  <div class="validation-message" [ngbPopover]="tooltip" triggers="click hover" container="body" popoverClass="validation-error"><esp-icon name="circle-alert"></esp-icon></div>
}
<!-- Accessibility (name, value and editable/read-only state) is applied to the
     AG Grid gridcell (params.eGridCell) in applyGridCellAria(), because JAWS
     reads the focused gridcell - not this non-focusable span.

     a11y (Option 2 - inline "edit row" pencil): editable rows show a pencil
     button in the parameter (row-header) cell. It is the single, discoverable
     entry point for starting to edit a row and is the control Dragon voice
     users click ("click Edit AHT Productive row"). It is kept OUT of the tab
     order (tabindex="-1") so the grid stays a single tab stop; keyboard users
     arrow-navigate onto the row-header cell (whose accessible name announces
     the editable row) and press Enter/Space to activate it via the column's
     suppressKeyboardEvent handler. Clicking it starts editing the first
     editable cell of the row and announces the edit-mode instructions. -->
@if (isParamLabelCell) {
  <div class="param-cell">
    <span class="param-label" [class.push-right]="isValidIndicator">{{getValueToDisplay(params)}}</span>
    @if (isRowEditable) {
      <button type="button"
              class="row-edit-button"
              tabindex="-1"
              [attr.aria-label]="rowEditAriaLabel"
              [title]="rowEditTooltip"></button>
    }
  </div>
} @else if (isEditField) {
  <!-- Dragon voice control (WCAG 4.1.2): an edit-field value shown as a plain
       <span> is not a control Dragon can recognise or target, so voice users
       cannot interact with the field's value. Rendering it as a native
       <button> gives Dragon a real interactive control whose accessible name is
       the visible value (e.g. "300,001"), so "click 300,001" selects the cell
       ready for editing. It is kept OUT of the tab order (tabindex="-1") so the
       grid stays a single tab stop and has NO click handler - the click bubbles
       to AG Grid, which focuses the cell exactly as clicking the value always
       did. The rich editable/read-only accessible name JAWS announces still
       lives on the focused gridcell (see applyGridCellAria). -->
  <button type="button" class="cell-value-button" tabindex="-1" [class.push-right]="isValidIndicator" [class.short-value]="isValidIndicator && isShortValue" [attr.title]="isValidIndicator ? getValueToDisplay(params) : null">{{getValueToDisplay(params)}}</button>
} @else {
  <span [class.push-right]="isValidIndicator" [class.short-value]="isValidIndicator && isShortValue" [attr.title]="isValidIndicator ? getValueToDisplay(params) : null">{{getValueToDisplay(params)}}</span>
}

<ng-template #tooltip>
  <div class="message-text">
    <p>{{validationMessage | translate}}</p>
  </div>
</ng-template>
